module.exports = __webpack_public_path__ + "static/media/blog-data-img.c931fb97.png";